module.exports = __webpack_public_path__ + "static/media/mode-502.ffb3ef98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-502.svg
// module id = 1057
// module chunks = 2